import { styled } from "styled-components";
import { Sidebar } from "@kitbird/core";

const KitSidebar = styled(Sidebar)`
  max-height: 100vh;
  width: 280px;
  height: auto !important;
  span {
    text-align: left;
    min-width: 120px;
  }
`;

export default KitSidebar;
